<template>
    <b-container class="wrapper h-100" fluid>
        <b-row class="h-100 cover"><h1>Servicios de innovación y transformación estratégica</h1></b-row>
        <b-row class="h-100 first" align-v="stretch" align-h="center">
            <b-col col xs="12" sm="12" md="12" xl="12" lg="12">
                <b-row class="h-100" align-v="center" align-h="center">
                    <b-col class="service-link h-100 sl1a" @mouseover="animateOver" @mouseout="animateOut" @click="goto('/innovacion-basada-en-datos')" col xs="12" sm="12" md="12" xl="6" lg="6">
                        <b-row class="h-100" align-v="center">
                            <b-col>
                                <div class="floater">
                                    <h2 class="text">Innovación<br>basada en datos.</h2>
                                    <div>
                                        <p class="description">Generamos certidumbre para enfocar los recursos en ideas ganadoras al invertir en innovación.</p>
                                    </div>
                                    <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="service-link h-100 sl1b" @mouseover="animateOver" @mouseout="animateOut" @click="goto('/investigacion-de-usuarios')" col xs="12" sm="12" md="12" xl="6" lg="6">
                        <b-row class="h-100" align-v="center">
                            <b-col col xs="12" md="6">
                                <h2 class="text">Investigación<br>de usuarios.</h2>
                                <div>
                                    <p class="description">Creamos una base de clientes fidelizada e incrementamos tus ventas a través del conocimiento profundo de tus usuarios a profundidad.</p>
                                </div>
                                <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <b-col col xs="12" sm="12" md="12" xl="12" lg="12">
                <b-row class="h-100" align-v="center" align-h="center">
                    <b-col class="service-link h-100 sl2a" @mouseover="animateOver" @mouseout="animateOut" @click="goto('/innovacion-en-capital-humano')" col xs="12" sm="12" md="6" xl="6" lg="6">
                        <b-row class="h-100" align-v="center">
                            <b-col>
                                <div class="floater">
                                    <h2 class="text">Innovación en<br>capital humano.</h2>
                                    <div>
                                        <p class="description">Diseñamos una cultura enfocada en tus colaboradores para generar compromiso, sentido de pertenencia, autonomía y capacidad de innovación.</p>
                                    </div>
                                    <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="service-link h-100 sl2b" @mouseover="animateOver" @mouseout="animateOut" @click="goto('/diseno-de-servicios')" col xs="12" sm="12" md="6" xl="6" lg="6">
                        <b-row class="h-100" align-v="center">
                            <b-col col xs="12" md="6">
                                <h2 class="text">Diseño de<br>servicios.</h2>
                                <div>
                                    <p class="description">Creamos servicios que generen experiencias inolvidables para tus clientes y hagan uso eficiente de los recursos. </p>
                                </div>
                                <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <b-col col xs="12" sm="12" md="12" xl="12" lg="12">
                <b-row class="h-100" align-v="center" align-h="center">
                    <b-col class="service-link h-100 sl3a" @mouseover="animateOver" @mouseout="animateOut" @click="goto('/arquitectura-de-decisiones')" col xs="12" sm="12" md="6" xl="6" lg="6">
                        <b-row class="h-100" align-v="center">
                            <b-col>
                                <div class="floater">
                                    <h2 class="text">Arquitectura<br>de decisiones.</h2>
                                    <div>
                                        <p class="description">Diseñamos cambios simples con base en las ciencias del comportamiento y la psicología de las personas que generan impactos de gran escala.</p>
                                    </div>
                                    <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="service-link h-100 sl3b" @mouseover="animateOver" @mouseout="animateOut" @click="goto('/workshops-para-organizaciones')" col xs="12" sm="12" md="6" xl="6" lg="6">
                        <b-row class="h-100" align-v="center">
                            <b-col col xs="12" md="6">
                                <h2 class="text">Workshops para<br>organizaciones.</h2>
                                <div>
                                    <p class="description">Nuestros consultores expertos ayudan a tu equipo a conducir procesos rápidos de innovación. Así pueden crear más oportunidades mientras desarrollan nuevas capacidades.</p>
                                </div>
                                <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import { gsap } from "gsap"
import { TimelineLite, Sine } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

import * as typeformEmbed from "@typeform/embed"

gsap.registerPlugin(ScrollTrigger)

import { eventBus } from '../main'

export default {
    name: 'Services',
    data() {
        return {
            timeline_hovers: ''
        }
    },
    metaInfo() {
        return {
            title: 'Servicios de consultoría en innovación estratégica | Ozmo',
            meta: [
                {name: 'description', content: 'Conoce nuestros servicios como agencia de transformación estratégica, de cultura organizacional, design thinking, investigación de usuarios y más.'},
                {name: 'keywords', content: 'Servicios de consultoría en innovación estratégica, consultora de innovación, agencia de transformación estratégica, consultora de cultura organizacional, consultoría en transformación para empresas, consultoría en cultura organizacional, proveedores de design thinking, agencias de investigación de usuarios, talleres para diseñar experiencias, consultoras con experiencia en área de capital humano, consultoras en innovación con experiencia sector financiero, agencia de innovación empresarial'},
                {name: 'robots', content: 'index,follow'},
                {name: 'viewport', content: 'width=device-width,initial-scale=1,user-scalable=no' },
                {charset: 'utf-8' },
                {property: 'og:title', content: 'Servicios de consultoría en innovación estratégica | Ozmo'},
                {property: 'og:site_name', content: 'Ozmo | Diseño de futuros'},
                {property: 'og:description', content: 'Conoce nuestros servicios como agencia de transformación estratégica, de cultura organizacional, design thinking, investigación de usuarios y más.'},
                {property: 'og:url', content: 'https://ozmo.mx'},
                {property: 'og:type', content: 'website'},
                {property: 'og:image', content: 'https://s3-us-west-2.amazonaws.com/cdn.ozmo.mx/ozmo_coral.png'}
            ]
        }
    },
    methods: {
        goto(navigation) {
            eventBus.$emit('gotoNavigation', navigation)
        },
        launchProspector() {
            typeformEmbed.makePopup(
                'https://ozmomx.typeform.com/to/vwqXW6',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
                )
        },
        animateOver(e) {
            // console.log(e.currentTarget)
            this.timeline_hovers = new TimelineLite()

            this.timeline_hovers.fromTo(e.currentTarget.querySelector('h2'), 0.5, {color: '#FFFFFF'}, {
                ease: Sine.easeInOut,
                color: '#454545'
            }).fromTo(e.currentTarget.querySelector('.icon'), 0.5, {color: '#FFFFFF'}, {
                ease: Sine.easeInOut,
                color: '#454545'
            }, "-=0.5").fromTo(e.currentTarget.querySelector('.description'), 0.5, {color: '#FFFFFF', autoAlpha: 0}, {
                ease: Sine.easeInOut,
                color: '#454545',
                autoAlpha: 1
            }, "-=0.5").fromTo(e.currentTarget.querySelector('div .description'), 0.5, {height:'0px'}, {
                ease: Sine.easeInOut,
                height: 'auto'
            }, "-=0.5").fromTo(e.currentTarget, 0.5, {backgroundColor: '#01F1BA00'}, {
                ease: Sine.easeInOut,
                backgroundColor: '#01F1BA'
            }, "-=0.5")
        },
        animateOut() {
            this.timeline_hovers.reverse(0)
        },
        launchContact() {
            typeformEmbed.makePopup(
                // `https://ozmomx.typeform.com/to/dTWHb81Q?source=web-${this.$route.name}`,
                // 'https://ozmomx.typeform.com/to/YPa8WK93?utm_source=website&utm_medium=section&utm_campaign=website2022&utm_content=services',
                'https://www.cognitoforms.com/Kinit1/ContactoWeb?entry={"Leads":{"Ref":"website-services"}}',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
                )
        },
        launchFontacto() {
            window.location='tel:+525585263310'
            this.$gtag('event', 'clic', {
                'event_category': 'telefono',
                'event_label': 'exitoso',
                'value': 'exitoso'
            });
        }
    },
    mounted() {
        // const { msg1, msg2 } = this.$refs
        const timeline_first = new TimelineLite({
            // scrollTrigger: {
            //     trigger: ".first"
            // }
        })

        timeline_first.fromTo('.cover', 1, {}, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            display: 'none',
        }).fromTo('.sl1a', 1, {x:-999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'initial',
            autoAlpha: 1,
            x: 0
        }, "-=0.7").fromTo('.sl1b', 1, {x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'initial',
            autoAlpha: 1,
            x: 0
        }, "-=0.7").fromTo('.sl2a', 1, {x:-999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'initial',
            autoAlpha: 1,
            x: 0
        }, "-=0.7").fromTo('.sl2b', 1, {x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'initial',
            autoAlpha: 1,
            x: 0
        }, "-=0.7").fromTo('.sl3a', 1, {x:-999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'initial',
            autoAlpha: 1,
            x: 0
        }, "-=0.7").fromTo('.sl3b', 1, {x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'initial',
            autoAlpha: 1,
            x: 0
        }, "-=0.7")

    },
    created() {
        eventBus.$emit('displayOverlay')
    }
}
</script>

<style scoped lang="stylus">

.wrapper
    // background-image url('../assets/bg_home.jpeg')
    // background-repeat no-repeat
    // background-size cover
    // background-color black
    width 100vw
    overflow-x hidden
    overflow-y scroll

    .cover
        background-color #000000
        width 100%
        position absolute

        h1
            visibility hidden

    .first
        background-image url(../assets/fondo_servicios.jpg)
        background-size cover
        background-repeat no-repeat
        background-position center right

        .floater
            float right
            width 55%

        .service-link
            cursor pointer
            padding-left 5rem
            padding-right 7rem

            h2, p, div
                pointer-events none

            h2
                text-align left
                white-space nowrap
                txt_style($archia-m, 40px, #FFFFFF)
                margin-bottom 0

            .description
                txt_style($archia-m, 16px, #FFFFFF)

            .icon
                text-align left
                txt_style($archia-m, 40px, #FFFFFF)

            div .description
                height 0px
                overflow hidden

@media screen and (max-width : 320px)

    .wrapper
        .first
            height 200% !important

            .floater
                float center
                width 100%
                margin-bottom 5rem 

            .sl1a 
                position inherit
                height 100px !important

            .sl1b
                position inherit
                height 100px !important

            .sl2a 
                position inherit
                height 100px !important

            .sl2b
                position inherit
                width 50%
                height 100px !important

            .sl3a 
                position inherit
                height 100px !important

            .sl3b
                position inherit
                height 100px !important  

            .service-link

                h2
                    txt_style($archia-m, 32px, #FFFFFF)

                .icon
                    txt_style($archia-m, 40px, #FFFFFF)

@media screen and (width : 414px) and (height : 736px)

    .wrapper
        .first
            height 200% !important

            .floater
                float center
                width 100%
                margin-bottom 5rem 

            .sl1a 
                position inherit
                height 100px !important

            .sl1b
                position inherit
                height 100px !important

            .sl2a 
                position inherit
                height 100px !important

            .sl2b
                position inherit
                width 50%
                height 100px !important

            .sl3a 
                position inherit
                height 100px !important

            .sl3b
                position inherit
                height 100px !important  

            .service-link

                h2
                    txt_style($archia-m, 32px, #FFFFFF)

                .icon
                    txt_style($archia-m, 40px, #FFFFFF)                    

@media screen and (max-width : 768px)

    .wrapper
        .first
            height 200% !important

            .floater
                float center
                width 100%
                margin-bottom 5rem 

            .sl1a 
                position inherit
                height 100px !important

            .sl1b
                position inherit
                height 100px !important

            .sl2a 
                position inherit
                height 100px !important

            .sl2b
                position inherit
                width 50%
                height 100px !important

            .sl3a 
                position inherit
                height 100px !important

            .sl3b
                position inherit
                height 100px !important  

            .service-link

                h2
                    txt_style($archia-m, 32px, #FFFFFF)

                .icon
                    txt_style($archia-m, 40px, #FFFFFF)   

@media screen and (width : 1024px) and (height : 1366px)

    .wrapper
        .first
            height 100% !important

            .floater
                float right
                width 100%

            .sl1a 
                position inherit
                height 100px !important

            .sl1b
                position inherit
                height 100px !important

            .sl2a 
                margin-top -25rem
                position inherit
                height 100px !important

            .sl2b
                margin-top -25rem
                position inherit
                height 100px !important

            .sl3a 
                margin-top -25rem
                position inherit
                height 100px !important

            .sl3b
                position inherit
                margin-top -25rem
                height 100px !important 


</style>
